import React, { useEffect, useState } from 'react';
import { TextField, Typography, Snackbar } from '@material-ui/core';
import CloseImage from '../../assets/ic_close.png';
import api from '../api';
import Fasilitas from './fasilitas';
import Autocomplete from '@material-ui/lab/Autocomplete';

export default function AddSubFasilitas(props) {

    const [nama, setNama] = useState("")
    const [fasilitas, setFasilitas] = useState(null)
    const [tipeAntrian, setTipeAntrian] = useState(null)
    const [listFacility, setListFacility] = useState([])
    const [antrian, setAntrian] = useState(null)
    const [listAntrian] = useState([
        { value: 'Tidak', id: 0 },
        { value: 'Ya', id: 1 },
    ])
    const [listTipeAntrian] = useState([
        { name: 'Sub Fasilitas', id: 1 },
        { name: 'Dokter', id: 2 },
    ])
    const [listExecutive] = useState([
        { name: 'Ya', id: 1 },
        { name: 'Tidak', id: 0 },
    ])
    const [executive, setExecutive] = useState(listExecutive[1])
    const [kodeAntrian, setKodeAntrian] = useState("")
    const [dataEksternal, setDataEksternal] = useState([])
    const [eksternal, setEksternal] = useState(null)
    const [catatan, setCatatan] = useState("")
    const [listDefault, setListDefault] = useState([])
    const [pickDefault, setPickDefault] = useState(null)
    const [errorName, setErrorName] = React.useState(false);
    const [errorFasilitas, setErrorFasilitas] = React.useState(false);
    const [errorKode, setErrorKode] = React.useState(false);
    const [texterrorKode, setTextErrorKode] = React.useState(null);
    const [texterrorName, setTextErrorName] = React.useState(null);
    const [textErrorFasilitas, setTextErrorFasilitas] = React.useState(null);
    const [textErrorTipeAntrian, setTextErrorTipeAntrian] = React.useState(null);
    const [errorTipeAntrian, setErrorTipeAntrian] = React.useState(false);

    useEffect(() => {
        getDataFasilitas()
        getDefault()
        setAntrian(listAntrian[0])
        getEksternalCode()
        forceUpdate()
    }, [])

    const getEksternalCode = () => {
        api.create().getEksternalCodeSubFacility().then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    let data = response.data.data
                    let listEksternal = []
                    data.map((item, index) => {
                        if (item.status === 1) {
                            listEksternal.push({
                                nama: item.name,
                                id: item.code
                            })
                        }
                    })
                    setDataEksternal(listEksternal)
                }
            }
        })
    }

    const getDataFasilitas = () => {
        api.create().getAllFacility().then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    let data = response.data.data
                    let listFacility = []
                    data.map((item, index) => {
                        if (item.status === 1) {
                            listFacility.push({
                                nama: item.name,
                                id: item.id
                            })
                        }
                    })
                    setListFacility(listFacility)
                }
            }
        })
    }

    const getDefault = () => {
        api.create().getDefaultSubFacility().then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    let listDefault = []
                    response.data.data.map((item) => {
                        listDefault.push({
                            id: item.id,
                            value: item.name
                        })
                    })
                    setListDefault(listDefault)
                }
            }
        })
    }

    const forceUpdate = React.useReducer(bool => !bool)[1];

    const handleSave = () => {
        if (fasilitas === null) {
            setErrorFasilitas(true)
            setTextErrorFasilitas("Fasilitas wajib diisi")
        } else if (!nama) {
            setErrorName(true)
            setTextErrorName("Nama Sub Fasilitas wajib diisi")
        } else if (tipeAntrian === null) {
            setTipeAntrian(true)
            setTextErrorTipeAntrian("Tipe Antrian wajib diisi")
        } else if (!kodeAntrian) {
            setErrorKode(true)
            setTextErrorKode("Kode Antrian wajib diisi")
        } else {
            let payload = {
                "facility_id": fasilitas === null ? null : fasilitas.id,
                "name": nama,
                "queue_code": kodeAntrian,
                "auto_generate_queue": antrian.id,
                "external_code": eksternal === null ? null : eksternal.id,
                "notes": catatan,
                "default_sub_facility_id": pickDefault === null ? null : pickDefault.id,
                "default_queue_type": tipeAntrian.id,
                "is_executive": executive.id,
            }
            props.createSubFacility(payload)
        }
    }

    return (
        <div className="App app-popup-show">
            <div className="popup-content background-white" style={{ borderRadius: 8, backgroundColor: 'white' }}>
                <div className="popup-panel grid grid-2x main-color" style={{ height: 64, borderTopRightRadius: 8, borderTopLeftRadius: 8 }}>
                    <div className="col-1" style={{ maxWidth: "inherit", display: 'flex', alignItems: 'center' }}>
                        <div className="popup-title">
                            <span style={{ color: 'black', fontSize: 18, }}>Tambah Sub Fasilitas Baru</span>
                        </div>
                    </div>
                    <div className="col-2 content-right" style={{ maxWidth: "inherit", alignSelf: 'center' }}>
                        <button
                            type="button"
                            className="btn btn-circle btn-white"
                            onClick={() => props.onClose()}
                        >
                            <img src={CloseImage} style={{ width: 20, height: 20 }} />
                        </button>
                    </div>
                </div>
                <div className="grid grid-2x grid-mobile-none gap-15px" style={{ padding: 20, paddingRight: 50, paddingLeft: 50 }}>
                    <div className="column-1">
                        <Autocomplete
                            options={listFacility}
                            getOptionLabel={(option) => option.nama}
                            disableClearable
                            // debug
                            name='fasilitas'
                            id="tipe"
                            onChange={(event, newInputValue) => {
                                setFasilitas(newInputValue)
                                setErrorFasilitas(false)
                                setTextErrorFasilitas(null)
                                forceUpdate()
                            }}
                            renderInput={(params) =>
                                <TextField
                                    {...params}
                                    InputProps={{ ...params.InputProps, style: { fontSize: 13 } }}
                                    InputLabelProps={{ style: { color: '#7e8085' } }}
                                    label="Fasilitas"
                                    required={true}
                                    error={errorFasilitas}
                                    helperText={textErrorFasilitas}
                                />
                            }
                            value={fasilitas}
                        />
                        <div className="">
                            <TextField
                                style={{ width: '100%', marginTop: 15 }}
                                id="queueCode"
                                name="queueCode"
                                label="Kode Antrian"
                                placeholder={"input Kode Antrian"}
                                required={true}
                                error={errorKode}
                                helperText={texterrorKode}
                                onChange={(e) => {
                                    setKodeAntrian(e.target.value)
                                    setErrorKode(false)
                                    setTextErrorKode(null)
                                    forceUpdate()
                                }}
                                inputProps={{
                                    style: {
                                        fontSize: 14,
                                    },
                                    maxlength: 2
                                }}
                                InputLabelProps={{
                                    style: {
                                        fontSize: 14,
                                        color: '#7e8085',
                                    }
                                }}
                            />
                        </div>
                        <Autocomplete
                            options={listAntrian}
                            getOptionLabel={(option) => option.value}
                            disableClearable
                            style={{ marginTop: 15 }}
                            // debug
                            name='antrian'
                            id="tipe"
                            onChange={(event, newInputValue) => {
                                setAntrian(newInputValue)
                                forceUpdate()
                            }}
                            renderInput={(params) =>
                                <TextField
                                    {...params}
                                    InputProps={{ ...params.InputProps, style: { fontSize: 13 } }}
                                    InputLabelProps={{ style: { color: '#7e8085' } }}
                                    label="Antrian Otomatis"
                                />
                            }
                            value={antrian}
                        />
                        <Autocomplete
                            options={listDefault}
                            getOptionLabel={(option) => option.value}
                            onChange={(event, newInputValue) => {
                                setPickDefault(newInputValue)
                                forceUpdate()
                            }}
                            style={{ marginTop: 15 }}
                            renderInput={(params) =>
                                <TextField
                                    {...params}
                                    InputProps={{ ...params.InputProps, style: { fontSize: 13 } }}
                                    InputLabelProps={{ style: { color: '#7e8085' } }}
                                    label="Default"
                                />
                            }
                            value={pickDefault}
                        />
                        <Autocomplete
                            options={listExecutive}
                            getOptionLabel={(option) => option.name}
                            onChange={(event, newInputValue) => {
                                setExecutive(newInputValue)
                                forceUpdate()
                            }}
                            style={{ marginTop: 15 }}
                            renderInput={(params) =>
                                <TextField
                                    {...params}
                                    InputProps={{ ...params.InputProps, style: { fontSize: 13 } }}
                                    InputLabelProps={{ style: { color: '#7e8085' } }}
                                    label="Eksekutif"
                                />
                            }
                            value={executive}
                        />
                    </div>
                    <div className="column-2">
                        <div className="">
                            <TextField
                                style={{ width: '100%' }}
                                id="nama"
                                name="nama"
                                label="Nama Sub Fasilitas"
                                placeholder={"input Nama Sub Fasilitas"}
                                required={true}
                                error={errorName}
                                helperText={texterrorName}
                                onChange={(e) => {
                                    setNama(e.target.value)
                                    setErrorName(false)
                                    setTextErrorName(null)
                                    forceUpdate()
                                }}
                                inputProps={{
                                    style: {
                                        fontSize: 14,
                                    }
                                }}
                                InputLabelProps={{
                                    style: {
                                        fontSize: 14,
                                        color: '#7e8085',
                                    }
                                }}
                            />
                        </div>
                        <Autocomplete
                            style={{ width: '100%', marginTop: 15 }}
                            options={listTipeAntrian}
                            getOptionLabel={(option) => option.name}
                            disableClearable
                            id="tipe"
                            onChange={(event, newInputValue) => {
                                setTipeAntrian(newInputValue)
                                setErrorTipeAntrian(false)
                                setTextErrorTipeAntrian(null)
                                forceUpdate()
                            }}
                            renderInput={(params) =>
                                <TextField
                                    {...params}
                                    InputProps={{ ...params.InputProps, style: { fontSize: 13 } }}
                                    InputLabelProps={{ style: { color: '#7e8085' } }}
                                    label="Tipe Antrian"
                                    required={true}
                                    error={errorTipeAntrian}
                                    helperText={textErrorTipeAntrian}
                                />
                            }
                        />
                        <div className="">
                            <TextField
                                style={{ width: '100%', marginTop: 15 }}
                                id="catatan"
                                name="catatan"
                                label="Catatan"
                                placeholder={"input Catatan"}
                                onChange={(e) => {
                                    setCatatan(e.target.value)
                                    forceUpdate()
                                }}
                                inputProps={{
                                    style: {
                                        fontSize: 14,
                                    }
                                }}
                                InputLabelProps={{
                                    style: {
                                        fontSize: 14,
                                        color: '#7e8085',
                                    }
                                }}
                            />
                        </div>
                        <Autocomplete
                            options={dataEksternal}
                            getOptionLabel={(option) => option.nama}
                            name='gedung'
                            id="gedung"
                            onChange={(event, newInputValue) => {
                                setEksternal(newInputValue)
                                forceUpdate()
                            }}
                            style={{ marginTop: 15 }}
                            renderInput={(params) =>
                                <TextField
                                    {...params}
                                    InputProps={{ ...params.InputProps, style: { fontSize: 13 } }}
                                    InputLabelProps={{ style: { color: '#7e8085' } }}
                                    label="Lokasi Eksternal"
                                />
                            }
                            value={eksternal}
                        />
                    </div>
                </div>
                <div className="border-top grid grid-2x" style={{ height: 56, backgroundColor: '#f5f5f5', paddingLeft: 20, paddingRight: 20, borderBottomLeftRadius: 20, borderBottomRightRadius: 20 }}>
                    <div className="column-1" style={{ alignSelf: 'center' }}>
                    </div>
                    <div className="column-2" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                        <div onClick={() => props.onClose()} style={{ height: 32, width: 50, backgroundColor: "transparent", borderRadius: 20, marginRight: 10, cursor: 'pointer' }} >
                            <Typography style={{ color: '#706d6d', fontSize: 15, marginTop: 5 }}>Batal</Typography>
                        </div>
                        <div onClick={(e) => handleSave()} style={{ height: 32, width: 150, backgroundColor: '#2a9c6c', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer' }} >
                            <Typography style={{ color: 'white', fontSize: 15, marginTop: 5 }}>Simpan</Typography>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}